import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

const Hero = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div className=" px-[20px] mt-[60px] font-serif lg:px-[200px]" id="home">
      <div className="py-[20px] md:py-[80px] flex flex-col-reverse gap-6 justify-center items-center lg:gap-0 lg:flex-row lg:justify-evenly ">
        <div className=" flex flex-col justify-center md:items-center lg:items-start gap-[20px] ">
          <div
            data-aos="fade-down-left"
            className="w-full md:w-3/4  flex flex-col gap-3 md:gap-6"
          >
            <h1 className="text-[#343D68] text-lg font-bold">
              <p>Hi👋, I'm a </p>
              <p className="text-xl whitespace-nowrap"> Frontend Developer</p>
            </h1>
            <p className="text-[#000000] text-justify">
              I'm <span className="font-bold">Idris Haruna,</span> a developer
              dedicated towards building user friendly websites and making the
              world a better place with lines of codes.
            </p>
            <button className="bg-[#E84949] text-[#FFFFFF] text-[18px] p-2 rounded w-[98px] h-[42px] hover:bg-[#1F1F38] duration-500">
              <a href="https://drive.google.com/file/d/1xzhCwn0PYMr9a6IaNk5DPtbGYLcjXQ6g/view?usp=sharing">
                Resume
              </a>
            </button>
          </div>
        </div>

        <img
          data-aos="fade-right"
          src="/HeroImage.png"
          alt="profileImage"
          className="h-[300px] w-[600px] hidden lg:flex  "
        />
        <img
          src="/Idris.jpeg"
          alt="ProfileImage"
          className="h-[250px] w-[250px] md:h-[300px] md:w-[300px] lg:hidden rounded-full lg:rounded-xl shadow-lg shadow-[#343D68] "
        />
      </div>
    </div>
  );
};

export default Hero;
